/**
 * What the settings pages agree on about a draft: the re-seed rule shared by
 * the pages on the floating "Unsaved changes" pill (settings-sheet useDraft),
 * and the footer's "Unsaved: username, password" note for the pages that
 * still end in a footer (settings-sheet SheetFooter).
 */

/**
 * The draft after its baseline moved (a refetch, a save's response): a draft
 * that was never edited — null, or still equal to the baseline it was seeded
 * from — follows the new baseline; an edited one keeps its edits. A draft
 * with no previous baseline to judge it by is kept. The baseline itself is
 * returned, not a copy, so the re-seed and revert() agree.
 */
export function followBaseline<T>(
  draft: T | null,
  prev: T | null,
  baseline: T,
  same: (a: T, b: T) => boolean,
): T {
  return draft === null || (prev !== null && same(draft, prev)) ? baseline : draft;
}

/** "Unsaved: a, b, +N more" (max labels spelled out), or null when clean. */
export function unsavedNote(labels: readonly string[], max = 4): string | null {
  if (labels.length === 0) return null;
  const shown = labels.slice(0, max);
  const more = labels.length - shown.length;
  return `Unsaved: ${shown.join(", ")}${more > 0 ? `, +${more} more` : ""}`;
}
